import types from './action-types';
import isArray from 'lodash/isArray';

const initialState = {
    processing: false,
    coordinates: [],
    axisId: 0
};

export default (state = initialState, action) => {
    let newState = state;

    switch (action.type) {
        case types.LOADING:
            newState = { processing: true, axisId: action.axisId };
            break;
        case types.COORDINATES_LOADED:
            newState = { ...state, processing: false, coordinates: action.coordinates };
            break;
    }

    return newState;
}


// WEBPACK FOOTER //
// ./App/components/modules/charts/reducer.js